<template>
  <dnd-grid-container class="drag-area-content" :layout="items" @update:layout="set_items">
    <dnd-grid-box
      v-for="box in items"
      :id="`box-${box.type}-${box.id}`"
      :key="box.id"
      v-click-outside.capture="on_click_outside"
      :box_id="box.id"
      @on-drag-update="clear_menu_id"
      @on-drag-start="handle_drag_start(box)"
      @on-drag-end="handle_drag_end(box)"
      @on-click-without-drag="on_click(box, $event)"
      @mousedown.native.stop=""
    >
      <component
        :is="`${box.type}-box`"
        :box="box"
        @button-connection="start_connect(box.id)"
        @hover="hover"
        @blur="blur"
      />
    </dnd-grid-box>
  </dnd-grid-container>
</template>

<script>
  import { WorksheetItemService } from '@pbx/services/WorksheetItemService';
  import {
    isClickOnBorder,
    isClickOnBox,
    isClickOnContent
  } from '@pbx/components/worksheets/action-types/dnd-item/_base/_hellpers';
  import { createNamespacedHelpers } from 'vuex';
  const { mapGetters, mapActions } = createNamespacedHelpers('pbx/worksheets/form');

  import DndGridContainer from '@app/plugins/dnd-zone/Container';
  import DndGridBox from '@app/plugins/dnd-zone/Box';
  import EntryBox from '@pbx/components/worksheets/action-types/dnd-item/entry';
  import CallBox from '@pbx/components/worksheets/action-types/dnd-item/call';
  import QueueBox from '@pbx/components/worksheets/action-types/dnd-item/queue';
  import MenuBox from '@pbx/components/worksheets/action-types/dnd-item/menu';
  import PlaybackBox from '@pbx/components/worksheets/action-types/dnd-item/playback';
  import PostbackBox from '@pbx/components/worksheets/action-types/dnd-item/postback';
  import TimeBox from '@pbx/components/worksheets/action-types/dnd-item/time';
  import ListBox from '@pbx/components/worksheets/action-types/dnd-item/list';

  import { directive as clickOutside } from 'v-click-outside-x';
  import debounce from 'lodash-es/debounce';
  import { WorksheetActionModelSelector } from '@pbx/helpers/worksheets/action-types';
  import { WorksheetActionModalService } from '@pbx/modals/WorksheetActionModalService';

  export default {
    directives: { clickOutside },
    components: {
      DndGridContainer,
      DndGridBox,
      EntryBox,
      CallBox,
      QueueBox,
      MenuBox,
      PlaybackBox,
      PostbackBox,
      TimeBox,
      ListBox
    },

    data: () => ({
      coordinates: {
        x: 0,
        y: 0,
      }

    }),
    computed: {
      ...mapGetters({
        items: 'getActions',
        worksheet_id: 'getId',
        get_action_by_id: 'getActionById',
        is_menu_open: 'isMenuOpen',
        connect_from_id: 'getConnectionIdFrom'
      }),

      is_connect_start: function() {
        return this.connect_from_id > 0;
      }
    },

    methods: {
      ...mapActions({
        set_items: 'setActions',
        save_last_position: 'saveLastPosition',

        set_menu_id: 'setMenuId',
        clear_menu_id: 'clearMenuId',

        set_connection_to_id: 'setConnectionIdTo',
        get_allow_connection: 'getAllowConnection',
        start_connect: 'startConnect',
        continue_connect: 'continueConnect',
        end_connect: 'endConnect',

        reset_connect: 'resetConnect',
        save_connect: 'saveConnect',

        update_item: 'updateItem',
        
      }),


      handle_drag_start: function(box) {
        this.coordinates = {
          x: box.position.x,
          y: box.position.y
        }
        
      },
      handle_drag_end: function(box)  {
        if(this.coordinates.x !== box.position.x  ||
          this.coordinates.y !== box.position.y) {
          this.save();
        }
        
      },
     
      save: function() {
        /**
         * Сохраняем элементы у которых поменялась позиция
        **/
        this.items.forEach(item => {
          if(Number.isInteger(item.id)) {
            this.save_last_position(item);
            const backend_item = WorksheetActionModelSelector.getFrontendModel(item).toBackend();

            [
              WorksheetItemService.savePosition(
                backend_item.type,
                this.worksheet_id,
                backend_item.id,
                backend_item.getPosition()),
                
              WorksheetItemService.getItem(
                backend_item.type,
                this.worksheet_id,
                backend_item.id,
              )].reduce((p, f)  => p.then(f), Promise.resolve());
            
          }
        });
      },

      continue_connect: function(id) {
        if (!this.is_connect_start) {
          this.start_connect(id);
        } else {
          this.before_end_connect(id);
        }
      },

      before_end_connect: function(to_id) {
        this.get_allow_connection({ from_id: this.connect_from_id, to_id: to_id }).then(
          connections => {
            const count_free_connections = connections.length;

            if (count_free_connections > 1) {
              this.show_connection_modal(connections[0]);
            } else if (count_free_connections === 1) {
              const { from, to, type } = connections[0];

              this.save_connect({
                from_id: from.id,
                to_id: to.id,
                type: type
              });
            } else {
              this.reset_connect();
            }
          }
        );
      },

      show_connection_modal: function(connection) {
        const { from, to } = connection;
        const $el = document.getElementById(`box-${to.type}-${to.id}`);

        WorksheetActionModalService.create_connection(from, to, $el).on('confirm', choice => {
          WorksheetActionModalService.modal.setLoading(true);
          const { from, to, type } = choice;

          this.save_connect({
            from_id: from.id,
            to_id: to.id,
            type: type
          }).finally(() => {
            WorksheetActionModalService.modal.setLoading(false);
            WorksheetActionModalService.modal.remove();
          });
        });
      },

      hover: function(box) {
        this.set_connection_to_id(box.id);
      },

      blur: function() {
        this.set_connection_to_id(null);
      },

      on_click: function(box, evt) {
        if (this.connect_from_id) {
          /**
           * Если мы уже начали создавать связь, то продолжаем.
           * Нам не нужно запускать меню и т.п
           */
          this.before_end_connect(box.id);
        } else {
          /**
           * Если связи еще не было - то
           *  - Клик по контентной части обрабатываем как открытие меню
           *  - Клик по бордеру - пытаемся создать связь
           */
          if (isClickOnContent(evt.target)) {
            if (this.is_menu_open(box.id)) {
              this.clear_menu_id();
            } else {
              this.set_menu_id(box.id);
            }
          } else if (isClickOnBorder(evt.target)) {
            this.continue_connect(box.id);
          }
        }
      },

      on_click_outside: function(evt) {
        if (!isClickOnBox(evt.target)) {
          this.reset_connect();
        }

        if (!isClickOnContent(evt.target)) {
          this.clear_menu_id();
        }
      }
    }
  };
</script>

<style lang="scss">
  .drag-area-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 4000px;
    height: 4000px;
  }
</style>
